import React from "react";
import Star from "../../assets/Star.png";

const InstructorCard = ({ instructor }) => {
  return (
    <div className="bg-white rounded-[18px] shadow-[0_0_9.8px_1px_#00000040] p-6 2xl:px-8 2xl:pt-8 2xl:pb-11">
      {/* Profile Image */}
      <div className="flex gap-2 items-center">
        <div className="w-20 h-20 2xl:w-[119px] 2xl:h-[119px] p-1.5 rounded-full border border-black overflow-hidden">
          <img
            src={instructor.image}
            alt={instructor.name}
            className="w-full h-full object-cover rounded-full"
          />
        </div>
        <div>
          <h3 className="leading-5 font-bold">{instructor.name}</h3>
          <p className=" text-[#938A96] leading-5 mt-1">{instructor.email}</p>
          <div className="inline-flex  items-center gap-1.5 mt-2">
               <img
              src={Star}
              alt="star"
              className={`size-[18px]`}
            /> 
            <span className="leading-5">{instructor.rating}</span>
          </div>
        </div>
      </div>

      {/* Title */}
      <h4 className=" font-bold leading-[18px] text-[15px] mb-2.5 mt-7">
        {instructor.title}
      </h4>

      {/* Description */}
      <p className=" pr-4 leading-[19px] ">
        {instructor.description}
      </p>
    </div>
  );
};

export default InstructorCard;
